<template>
    <div>
        <h4>Add a note to selected stops</h4>
        <div class="note-input">
            <md-field>
                <label>Note</label>
                <md-textarea v-model="noteModel" md-autogrow></md-textarea>
            </md-field>

            <div class="note-type-container">
                <div class="type-field">
                    <label class="custom-label">Type</label>
                    <md-field>
                        <md-select v-model="typeModel" md-no-validate>
                            <md-option v-for="type in noteTypes" :key="type.name" :value="type.name">
                                {{ type.name }}
                            </md-option>
                        </md-select>
                    </md-field>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { NOTE_TYPE_CONSTANTS, STOP_NOTE_TYPE_CONSTANTS } from '@/utils/constants';

export default {
    name: 'AddStopNote',
    props: {
        selectedNote: {
            type: String,
            default: ''
        },
        selectedNoteType: {
            type: String,
            default: 'Stop Note'
        }
    },
    data() {
        return {
            noteTypes: [...NOTE_TYPE_CONSTANTS, ...STOP_NOTE_TYPE_CONSTANTS]
        };
    },
    computed: {
        noteModel: {
            get() {
                return this.selectedNote;
            },
            set(value) {
                this.$emit('note-selected', value);
            }
        },
        typeModel: {
            get() {
                return this.selectedNoteType;
            },
            set(value) {
                this.$emit('note-type-selected', value);
            }
        }
    }
};
</script>

<style lang="scss" scoped>
.note-input {
    margin-top: 20px;
    max-width: 600px;
    position: relative;
}

.note-type-container {
    margin-top: 20px;
    max-width: 300px;
}

.custom-label {
    display: block;
    margin-bottom: 5px;
}

/* Fix for dropdown text visibility */
::v-deep .md-select {
    .md-select-value {
        color: #000 !important;
    }

    .md-menu-content {
        .md-list-item-content {
            color: #000 !important;
        }
    }
}

::v-deep .md-input {
    -webkit-text-fill-color: #000 !important;
}

::v-deep .md-menu-content {
    .md-list {
        .md-list-item-content {
            color: #000 !important;
        }
    }
}
</style>
